import React from 'react';
import styled from 'styled-components'

const HOWTO = styled.section`
width: 100%;
overflow: hidden;

@media screen and (max-width: 48rem) {
    // margin-top: 40rem;
 }
 
@media screen and (min-width: 48rem) {
    height: 31.5rem

}

`

const HOWIMG = styled.img`
@media screen and (max-width: 48rem) {
    width: 100%;
    height: 15rem;
    margin: 0 auto 0 auto;
 }
@media screen and (min-width: 48rem) {
    

}
`

const ADVERT = styled.section`
@media screen and (max-width: 48rem) {
    margin-top: 4rem;
 }
@media screen and (min-width: 48rem) {
    width: 50%;
    align-self: center; 

}
`
// const VIDYOU = styled.iframe`

// @media screen and (max-width: 48rem) {
//    max-width: 335px;
//    margin-bottom: 2rem
// }
// @media screen and (min-width: 48rem) {
//     width: 95%;
//     margin: 1rem;

// }
// `

const INSTRUCTION = styled.article`
    background: #000000e8;
    padding: 1rem;
    color: #ffffffd1;
    & p strong {
        color: purple
    }
@media screen and (max-width: 48rem) {
    // margin-top: 3rem;
}
@media screen and (min-width: 48rem) {
    max-width: 45%;
    align-self: center; 
    // padding: 0 .1rem 0 .1rem;

}

`
const HowToUse = ({num, title, txt, flow}) => {
    return ( 
        <>

<HOWTO 
style={{display:'flex', justifyContent:'space-around', flexFlow:`${flow}`, flexWrap:'wrap-reverse', background: `url('https://c1.wallpaperflare.com/preview/363/888/917/beach-people-summer-tech.jpg') center center fixed`, backgroundSize:'cover', backgroundRepeat:'no-repeat' }}>

 
<ADVERT>
 

 <h3 style={{fontSize:'x-large', textAlign:'center', color: 'purple'}}> {title} </h3> 
 {/* <VIDYOU height="315" src="https://www.youtube.com/embed/mXyOB3ukyJg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></VIDYOU> */}
 <HOWIMG src={require('../Assets/Images/laptop-phone.png')} alt="how to use Iamwealthy" />

</ADVERT>
 <INSTRUCTION>
      
     {/* Using 'amwealthy comes in Just three(3) steps-  */}
         <p style={{lineHeight:'2.35rem'}}> <strong>Pay:</strong>To begin using our application we require you make payment of which will be monthly overtime</p>
         <br />
         <p style={{lineHeight:'2.35rem'}}> <strong>Quote:</strong> We keep our users inspired and motivated overtime as they use our app, reminding them of their commitments and best quotes 
          </p>
         <br />
          <p style={{lineHeight:'2.35rem'}}><strong>Structure:</strong>Our application allow you structure and configure your finance yourself while we use that model to help you manage it overtime </p>
         <br />
   
 </INSTRUCTION>
</HOWTO>

        </>
     );
}
 
export default HowToUse;